import {
  Step,
  StepIcon,
  StepIndicator,
  StepNumber,
  StepSeparator,
  StepStatus,
  Stepper,
  useSteps,
} from "@chakra-ui/react";
import { FormattedMessage, useIntl } from "react-intl";

import { RanaModal, TrashIcon } from "@nens/ranalib";

import { OverwriteState } from "../hooks/use-file-uploading-overwrite-modal";

import { FileUploadingOverwriteModalForm } from "./file-uploading-overwrite-modal-form";

export interface FileUploadingOverwriteModalProps {
  setOverwrites: (overwrites: OverwriteState["overwrites"] | null) => void;
  startOverwritesUpload: (overwrites: OverwriteState["overwrites"]) => void;
  overwriteState: OverwriteState;
}

export function FileUploadingOverwriteModal(props: FileUploadingOverwriteModalProps) {
  const { setOverwrites, overwriteState } = props;
  const { overwrites } = overwriteState;
  const { activeStep, setActiveStep } = useSteps({
    index: 0,
    count: overwrites.length,
  });
  const intl = useIntl();

  const onClose = () => setOverwrites(null);

  return (
    <RanaModal
      isOpen
      onClose={onClose}
      topBar={intl.formatMessage({
        id: "header.overwrite_files",
        defaultMessage: "Overwrite files",
      })}
      maxW="xl"
      h="fit"
    >
      <FormattedMessage
        id="heading.overwrite_explain"
        defaultMessage="Some files are going to be overwritten. You can change the name, choose not to upload them or overwrite them."
      />

      {overwrites.length > 1 && activeStep !== overwrites.length && (
        <Stepper mt={6} index={activeStep}>
          {overwrites.map((overwrite, idx) => (
            <Step onClick={() => setActiveStep(idx)} key={overwrite.currentFileIndex}>
              <StepIndicator>
                <StepStatus
                  complete={overwrite.dontOverwrite ? <TrashIcon /> : <StepIcon />}
                  incomplete={<StepNumber />}
                  active={<StepNumber />}
                />
              </StepIndicator>

              <StepSeparator />
            </Step>
          ))}
        </Stepper>
      )}

      <FileUploadingOverwriteModalForm
        {...props}
        setActiveStep={setActiveStep}
        activeStep={activeStep}
      />
    </RanaModal>
  );
}
